import { mount } from "navi";
import FormPage from "./form";

const pages = mount({
  "/": FormPage,
  "/form": FormPage,
});

export default pages;
